import Link from 'next/link';
import { useState } from 'react';
import ServiceDetailHeader from '../../molecules/ServiceDetailHeader';
import TermsConditionServices from '../../atoms/TermsConditionServices';
import Divider from '../../atoms/Divider';
import ServiceTags from '../../molecules/ServiceTags';
import { IServiceProduct } from '../../atoms/TypeCarModal';
import { ITermAndConditions } from '../../molecules/TermAndConditions';
import { useSelector } from 'react-redux';
import dynamic from 'next/dynamic';
import ServiceDetailOptions from '../../molecules/ServiceDetailOptions';
import { IBreadcrumbs } from '../../molecules/Breadcrumbs';

const ServiceDetailBanner = dynamic(() => import('../../molecules/ServiceDetailBanner'), {
  ssr: true,
  loading: () => <div className="flex w-full xl:w-[580px] lg:w-[450px] h-[27.5vh] md:h-auto"></div>,
});
const ServiceDetailResult = dynamic(() => import('../../molecules/ServiceDetailResult'), {
  ssr: true,
  loading: () => <div className="w-full h-[560px] md:h-[750px]"></div>,
});
const Arrow = dynamic(() => import('../../atoms/Icons/Arrow'), {
  ssr: false,
});
const ModalServiceDetailOptions = dynamic(() => import('../ModalServiceDetailOptions'), {
  ssr: false,
});

interface ServiceDetailSectionProps {
  titleChoosePackage?: string;
  titlePrice: string;
  serviceType: string;
  servicePlan: {
    firstPeriodicServiceTitle: {
      name: string;
      value: string[];
    }[];
    firstPeriodicServiceDetail: {
      name: string;
      value: string[];
    }[];
  };
  isCMS?: boolean;
  serviceContent: {
    couponPacketServiceContent?: {
      imageUrl?:
        | {
            imageUrl?: string;
            imageAlt?: string;
            detail?: any;
          }
        | string;
      imageAlt?: string;
      titlePage?: string;
      descriptionPage?: string;
      titleVoucher?: string;
      descriptionVoucher?: string;
      carCategory?: string;
      detail?: any;
    };
  };
  termCondition?: ITermAndConditions;
  serviceProductList?: IServiceProduct[];
  serviceModelTag?: Array<{ text: string; iconUrl: string; hide?: boolean }>;
  triggerGTM?: {
    status: boolean;
  };
  // titleCoupon?: string;
  serviceProductTitle?: string;
  serviceDiscounts?: string;
  bodyTypeName?: string;
  breadCrumbTitle?: string;
  breadcrumbItems?: IBreadcrumbs[];
  feature?: string;
}

const ServiceDetailSection = ({
  titleChoosePackage,
  titlePrice,
  serviceType,
  servicePlan,
  isCMS = false,
  serviceContent,
  termCondition,
  serviceProductList = [],
  serviceModelTag = [],
  triggerGTM,
  // titleCoupon,
  serviceProductTitle,
  serviceDiscounts,
  bodyTypeName,
  breadCrumbTitle,
  breadcrumbItems,
  feature,
}: ServiceDetailSectionProps) => {
  const [viewTypeCar, setViewTypeCar] = useState(false);
  const [viewPackageCarModal, setViewPackageCarModal] = useState(false);
  const [showTermsModal, setShowTermsModal] = useState(false);
  const [showTermsModalTnc, setShowTermsModalTnc] = useState(false);
  const [showVoucherModal, setShowVoucherModal] = useState(false);
  const { selectedCar, selectedPackage } = useSelector((state: any) => state.servicePackage);

  return (
    <div className="pt-4 lg:pt-6">
      <Link href={'/'} className="block px-4 mb-3 lg:hidden">
        <Arrow size={24} color="#393536" direction={'left'} />
      </Link>

      <div className="grid grid-cols-1 lg:container xl:px-0 lg:grid-cols-[1.5fr_2fr] lg:gap-[52px]">
        <ServiceDetailBanner
          imageUrl={
            typeof serviceContent?.couponPacketServiceContent?.imageUrl === 'string'
              ? {
                  imageUrl: serviceContent?.couponPacketServiceContent?.imageUrl as string,
                  detail: serviceContent?.couponPacketServiceContent?.detail,
                  imageAlt: serviceContent?.couponPacketServiceContent?.imageAlt,
                }
              : serviceContent?.couponPacketServiceContent?.imageUrl
          }
          typeID={serviceType}
          isCMS={isCMS}
        />
        <ServiceTags
          items={serviceModelTag}
          className="block mb-1 lg:mb-4 lg:hidden"
          width="fit-content"
          isDetail
        />

        <div>
          <ServiceDetailHeader
            serviceModelTag={serviceModelTag}
            title={
              isCMS
                ? serviceContent?.couponPacketServiceContent?.titlePage
                : serviceContent?.couponPacketServiceContent?.titlePage?.toLowerCase() ===
                    breadCrumbTitle?.toLowerCase()
                  ? serviceContent?.couponPacketServiceContent?.titlePage
                  : breadCrumbTitle
            }
            desc={serviceContent?.couponPacketServiceContent?.descriptionPage}
            isCMS={isCMS}
            dataGTM={{
              category: {
                type: serviceType,
              },
              contentCategory: {
                name: serviceContent?.couponPacketServiceContent?.carCategory,
              },
              titlePage: selectedPackage?.name,
              carName: selectedCar?.vehicleName,
              serviceProductTitle: serviceProductTitle,
            }}
            serviceType={serviceType}
            serviceDiscounts={serviceDiscounts as any}
            impressionData={{
              pageTitle: isCMS
                ? serviceContent?.couponPacketServiceContent?.titlePage
                : serviceContent?.couponPacketServiceContent?.titlePage?.toLowerCase() ===
                    breadCrumbTitle?.toLowerCase()
                  ? serviceContent?.couponPacketServiceContent?.titlePage
                  : breadCrumbTitle,
              breadCrumb: breadcrumbItems,
            }}
            feature={feature}
          />

          {/* Type car & package options */}
          <ServiceDetailOptions
            showVoucherModal={setShowVoucherModal}
            setViewPackageCarModal={setViewPackageCarModal}
            setViewTypeCar={setViewTypeCar}
            titleChoosePackage={titleChoosePackage}
            viewTypeCar={viewTypeCar}
            serviceType={serviceType}
            isCMS={isCMS}
            serviceContent={serviceContent}
            triggerGTM={triggerGTM}
            serviceProductTitle={serviceProductTitle}
            bodyTypeName={bodyTypeName}
            serviceProductList={serviceProductList}
            serviceDiscounts={serviceDiscounts as any}
            emarsysData={{
              pageTitle: isCMS
                ? serviceContent?.couponPacketServiceContent?.titlePage
                : serviceContent?.couponPacketServiceContent?.titlePage?.toLowerCase() ===
                    breadCrumbTitle?.toLowerCase()
                  ? serviceContent?.couponPacketServiceContent?.titlePage
                  : breadCrumbTitle,
              breadcrumbItems,
            }}
            feature={feature}
          />

          <ServiceDetailResult
            titlePrice={titlePrice}
            serviceType={serviceType}
            servicePlan={servicePlan}
            viewPackageCarModal={viewPackageCarModal}
            serviceProductList={serviceProductList}
            emarsysData={{
              pageTitle: isCMS
                ? serviceContent?.couponPacketServiceContent?.titlePage
                : serviceContent?.couponPacketServiceContent?.titlePage?.toLowerCase() ===
                    breadCrumbTitle?.toLowerCase()
                  ? serviceContent?.couponPacketServiceContent?.titlePage
                  : breadCrumbTitle,
              breadcrumbItems,
            }}
            feature={feature}
          />

          <Divider additionalClassName="h-2" bgColor="bg-reliableBlack5" hideOnDesktop={true} />

          <TermsConditionServices
            setShowTermsModalTnc={setShowTermsModalTnc}
            isCMS={isCMS}
            termCondition={termCondition}
            showFullContent={false}
            emarsysData={{
              pageTitle: isCMS
                ? serviceContent?.couponPacketServiceContent?.titlePage
                : serviceContent?.couponPacketServiceContent?.titlePage?.toLowerCase() ===
                    breadCrumbTitle?.toLowerCase()
                  ? serviceContent?.couponPacketServiceContent?.titlePage
                  : breadCrumbTitle,
              breadcrumbItems,
            }}
            feature={feature}
          />

          <Divider additionalClassName="h-2" bgColor="bg-reliableBlack5" hideOnDesktop={true} />
        </div>
      </div>

      <ModalServiceDetailOptions
        setShowVoucherModal={setShowVoucherModal}
        setShowTermsModal={setShowTermsModal}
        setViewPackageCarModal={setViewPackageCarModal}
        setViewTypeCar={setViewTypeCar}
        setShowTermsModalTnc={setShowTermsModalTnc}
        viewTypeCar={viewTypeCar}
        showVoucherModal={showVoucherModal}
        showTermsModal={showTermsModal}
        showTermsModalTnc={showTermsModalTnc}
        viewPackageCarModal={viewPackageCarModal}
        termCondition={termCondition}
        serviceProductList={serviceProductList}
        serviceType={serviceType}
        serviceContent={serviceContent}
        serviceProductTitle={serviceProductTitle}
        triggerGTM={triggerGTM}
        isCMS={isCMS}
        serviceDiscounts={isCMS ? undefined : serviceDiscounts}
        bodyTypeName={bodyTypeName}
        feature={feature}
        impressionData={{
          pageTitle: isCMS
            ? serviceContent?.couponPacketServiceContent?.titlePage
            : serviceContent?.couponPacketServiceContent?.titlePage?.toLowerCase() ===
                breadCrumbTitle?.toLowerCase()
              ? serviceContent?.couponPacketServiceContent?.titlePage
              : breadCrumbTitle,
          breadcrumbItems,
        }}
      />
    </div>
  );
};

export default ServiceDetailSection;
